import SelectController from "./select_controller";
import TomSelect from "tom-select";

export default class extends SelectController {
  initializeTomSelect() {
    let config = {
      maxOptions: null,
      searchConjunction: "or",
      allowEmptyOption: this.allowEmptyOptionValue,
      hidePlaceholder: true,
      onChange: function () {
        // shows placeholder if null value is selected
        !this.getValue() && this.clear(true);
      },
      onItemAdd: function () {
        this.setTextboxValue("");
      },
    };

    if (this.withRemoveButtonValue) {
      config = {
        ...config,
        plugins: {
          remove_button: { title: "remove" },
        },
      };
    }

    if (this.withTagsValue) {
      const self = this; // needed to add scope into the config[:render]
      config = {
        ...config,
        items: this.getExistingValues(),
        render: {
          item: this.boundTagItemRender,
        },
      };
    }

    new TomSelect(this.element, config);
  }

  getExistingValues() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.getAll(this.element.name);
  }
}
